import { render, staticRenderFns } from "./ParticipantDetailedInfo.vue?vue&type=template&id=4f3421b8&scoped=true"
import script from "./ParticipantDetailedInfo.vue?vue&type=script&lang=js"
export * from "./ParticipantDetailedInfo.vue?vue&type=script&lang=js"
import style0 from "./ParticipantDetailedInfo.vue?vue&type=style&index=0&id=4f3421b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3421b8",
  null
  
)

export default component.exports